import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemAddButton,
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { CustomerBlockStatus } from '../../../../../NewApplication/Customer/components/TableItem/components/CustomerBlockStatus';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../ItemTag';

import { ResponsiveItemCustomerProps } from '.';

export const MobileItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  isSelected,
  addCustomerToCart,
  errorTags,
  isLoadingTags,
  refresherTags,
}) => {
  return (
    <TableContent
      direction="column"
      space={Spacing['inline.xxxs']}
      {...(isSelected && { bg: 'backgroundlight' })}>
      <HStack alignItems="center" justifyContent="space-between" w="full">
        <VStack>
          <Text
            color="neutral.darkest"
            variant="semibold"
            fontSize={Typography['fontsize.md']}
            noOfLines={1}>
            {item.name}
          </Text>
          <Text color="neutral.dark" fontSize={Typography['fontsize.xs']}>
            Conta {item.accountNumber}
          </Text>
        </VStack>
        <HStack space={Spacing['inline.quarck']}>
          <TableContentItemCaptions icons={mapCaptions(item)} />
          <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
        </HStack>
      </HStack>
      <VStack space={Spacing['stack.nano']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.black" fontSize={Typography['fontsize.md']}>
            CPF/CNPJ
          </Text>
          <Text color="neutral.black" fontSize={Typography['fontsize.md']}>
            {item.cpfCnpjFormatted}
          </Text>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.black" fontSize={Typography['fontsize.md']}>
            Cadastro
          </Text>
          <CustomerBlockStatus customer={item} />
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.black" fontSize={Typography['fontsize.md']}>
            Hashtag
          </Text>
          <ItemTag
            data={item.tags}
            itemId={item.customerId}
            errorTags={errorTags}
            isLoadingTags={isLoadingTags}
            refresherTags={refresherTags}
          />
        </HStack>
      </VStack>
      <HStack alignItems="center" justifyContent="space-between" w="full">
        <VStack>
          <Text color="neutral.dark" fontSize={Typography['fontsize.xs']}>
            Saldo Disponível
          </Text>
          <Text color="neutral.black" variant="semibold" fontSize={Typography['fontsize.lg']}>
            {item.availableBalanceFormatted}
          </Text>
        </VStack>
        <TableContentItemAddButton
          isSelected={isSelected}
          isDisabled={item.registrationBlocked}
          addCustomerToCart={addCustomerToCart}
        />
      </HStack>
    </TableContent>
  );
};
